module.exports = {
      id: "icon-cash-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-cash",
      toString: function () {
        return this.url;
      }
    }